<template>
  <div class="ppt-presenting-no-active horizontal layout center center-justified">
    <div class="vertical layout center center-justified relative">
      <button
        class="btn btn-primary start-button horizontal layout center"
        @click="startActiveSlide()"
        :disabled="isLoading"
      >
        {{ $t('Start AhaSlides') }} <aha-spinner v-if="isLoading" variant="white" class="loading-icon" />
      </button>
      <img src="@/assets/images/icon/arrow-to-top.svg" class="down-arrow" />
    </div>
    <BackToEditorButton class="back-to-edit" source="ppt-no-presenting" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import EventBus from '@/eventBus'

import BackToEditorButton from '@/components-v2/presentation-editor/middle/BackToEditorButton.vue'
import Socket from '@/socket'
import Config from '@/config'

export default {
  components: {
    BackToEditorButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
  },

  destroy() {
    this.isLoading = true
  },
  methods: {
    ...mapActions(['updatePresentation']),
    async startActiveSlide() {
      try {
        this.isLoading = true
        if (!this.$store.state.presentation.presenting) {
          EventBus.$emit('start-presenting-now')

          const payloadPresenting = {
            presenting: true,
            socketId: Socket.getSocketId(),
            activeSlidePreseting: this.$store.state.slideActive.id,
            activeSlideAccessCode: this.$store.state.presentation.uniqueAccessCode,
            presentFromPPT: true,
          }

          await this.$http
            .put(Config.api.updatePresentation + this.$store.state.presentation.id, payloadPresenting)
        }
        const payloadSlide = {
          activeSlide: this.$store.state.slideActive.id,
          socketId: Socket.getSocketId(),
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          timestamp: new Date().getTime(),
        }
        if (this.$store.state.slideActive.type !== 'leaderboard') {
          await this.$http.put(Config.api.updateNextSlide + this.$store.state.presentation.id, payloadSlide)
        }
        this.updatePresentation({
          activeSlide: this.$store.state.slideActive.id,
          presenting: true,
        })
        this.isLoading = false
        if (this.slideActive.type === 'leaderboard') {
          EventBus.$emit('sort-slide', () => {
            this.$http.put(Config.api.updateNextSlide + this.$store.state.presentation.id, payloadSlide)
          })
        }
      } catch (error) {
        Sentry.captureException(error)
      }
      // EventBus.$emit('makeSlideActive', this.$store.state.slideActive)
    },
  },
}
</script>

<style lang="scss" scoped>
.ppt-presenting-no-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  .start-button {
    border-radius: 40px;
    font-size: 20px;
    margin-bottom: 16px;
    padding-left: 32px;
    padding-right: 32px;
    border: 1px solid #fff;
    .loading-icon {
      margin-left: 4px;
      display: inline-block;
      position: relative;
      top: 4px;
    }
  }
  .back-to-edit {
    opacity: 1;
  }

  &::v-deep {
    .escape-presenting.__wrapper {
      opacity: 1;
      background-color:  #FFFFFFA6;

      &:hover {
        background-color:  #fff;
      }
    }
  }
}

.down-arrow {
  animation: jumpInfinite 1.5s infinite ease-in-out;
  position: absolute;
  bottom: -60px;
}

@keyframes jumpInfinite {
  0%, 100% {
    bottom: -60px;
  }
  50% {
    bottom: -42px;
  }
}
</style>
